export default __webpack_public_path__ + "static/work-roco-36dee12324d19f4e0616d29f8a90b54a.jpg";